<template>
    <div class="stepTwoRoot">
      <div class="circleItem"><CircleVue currentIndex="2"></CircleVue> </div>
      <div class="backPageItem"><BackPageVue  @backPreviewPage="hanldGoBack"></BackPageVue> </div>

        <div class="titleBox">
            <div class="titleLine">How Would You Like Us to Support Your Academic Growth?</div>
            <div class="subTitle">We offer personalized academic promotion services to <strong>boost your paper’s visibility</strong> while upholding the <strong>highest standards of academic integrity.</strong>
              Tell us which approach you’re most comfortable with — or mix and match.</div>

        </div>
      
        <div class="textBlock">
          <div  class="chooseBlock"  v-for="(item,index) in checkObj" :key="index">
            <div class="chooseIndex" style="color: rgb(254, 174, 0);">{{` ${index+1}、`}}</div> 
            <div class="chooseContext">
             <div class="chooseName"> 
              {{ item.name }}
              <div style="cursor: pointer;" v-if="index<4" @click="showPic(item.picObj)"> 
               <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" fill="none">
                      <path d="M14.9941 8C14.9941 4.13401 11.8601 1 7.99414 1C4.12815 0.999998 0.994142 4.134 0.994141 8C0.994138 11.866 4.12815 15 7.99414 15C11.8601 15 14.9941 11.866 14.9941 8ZM5.80249 6.6315C5.80249 5.42262 6.78511 4.44 7.99399 4.44C9.20288 4.44 10.1855 5.42262 10.1855 6.6315C10.1855 7.60163 9.4429 8.35248 8.701 8.65455C8.58005 8.70488 8.49403 8.82451 8.49403 8.97008V9.7675H7.49403V8.97008C7.49403 8.41041 7.83289 7.931 8.32041 7.7298L8.32296 7.72875C8.81772 7.52775 9.1855 7.07185 9.1855 6.6315C9.1855 5.9749 8.65059 5.44 7.99399 5.44C7.33739 5.44 6.80249 5.9749 6.80249 6.6315H5.80249ZM7.46673 11.1734C7.46673 10.8823 7.70277 10.6462 7.99395 10.6462C8.28513 10.6462 8.52117 10.8823 8.52117 11.1734C8.52117 11.4646 8.28513 11.7007 7.99395 11.7007C7.70277 11.7007 7.46673 11.4646 7.46673 11.1734Z" fill="#FEAE00"/>
                  </svg>
              </div>
              <div style="cursor: pointer;" v-else> 
                <el-tooltip class="item" effect="dark"  :content="item.toolTip" placement="right">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" fill="none">
                      <path d="M14.9941 8C14.9941 4.13401 11.8601 1 7.99414 1C4.12815 0.999998 0.994142 4.134 0.994141 8C0.994138 11.866 4.12815 15 7.99414 15C11.8601 15 14.9941 11.866 14.9941 8ZM5.80249 6.6315C5.80249 5.42262 6.78511 4.44 7.99399 4.44C9.20288 4.44 10.1855 5.42262 10.1855 6.6315C10.1855 7.60163 9.4429 8.35248 8.701 8.65455C8.58005 8.70488 8.49403 8.82451 8.49403 8.97008V9.7675H7.49403V8.97008C7.49403 8.41041 7.83289 7.931 8.32041 7.7298L8.32296 7.72875C8.81772 7.52775 9.1855 7.07185 9.1855 6.6315C9.1855 5.9749 8.65059 5.44 7.99399 5.44C7.33739 5.44 6.80249 5.9749 6.80249 6.6315H5.80249ZM7.46673 11.1734C7.46673 10.8823 7.70277 10.6462 7.99395 10.6462C8.28513 10.6462 8.52117 10.8823 8.52117 11.1734C8.52117 11.4646 8.28513 11.7007 7.99395 11.7007C7.70277 11.7007 7.46673 11.4646 7.46673 11.1734Z" fill="#FEAE00"/>
                  </svg>
                </el-tooltip>
              </div>
            </div>
             <div class="chooseSubtitle"  v-if="index<4"> {{ item.toolTip }}</div>
            </div>
           
          </div>
          
        </div>
      <!-- <el-checkbox-group  class="chooseBlock" v-model="checkArr" size="small">
            <el-checkbox  class="chooseItem"  v-for="(item,index) in checkObj" :key="index" :label="item.value"  border>{{ item.name }}</el-checkbox>
         </el-checkbox-group> -->
      <div class="btnLine">
          <!-- <div class="disBtn" v-if="checkArr.length==0">Next</div> -->
          <div class="chooseBtn"  @click="goToNextStep">Next</div>
      </div>
      <div class="LastLine2">
          <div class="oneItem">© 2025 PaperSpotlight. All rights reserved.</div>
          <!-- <div class="twoItem">The data presented is based on our independent research and analysis. While we strive for accuracy, results may vary across different fields and contexts. Unauthorized reproduction or distribution of this content is prohibited.</div> -->
      </div>
      <el-dialog class="twoDialog" title="" :visible.sync="dialogShow" >
            <div>
                <img v-for="item in dialogPic" :key="item" :src="require(`@/assets/img/main/${item}`)" style="width: 100%;height: auto;" alt="">

            </div>
            <div class="text">* Pinch to zoom in for more detail.</div>
        </el-dialog>
    </div>
</template>
<script>
import CircleVue from './circle.vue'
import BackPageVue from './backPage.vue'

export default {
    components:{CircleVue,BackPageVue},
    data(){
      return{
        imgObj:{
          guideHomebg1:require("../../assets/img/main/guideHomebg1.png"),
          guideHomebg2:require("../../assets/img/main/guideHomebg2.png"),
        },
        checkArr: [],
        checkObj:[
          {name:`ResearchGate Marketing`,picObj:['service001.jpeg'],toolTip:'Academic Research Oriented'},
          {name:`Linkedin Marketing`, picObj:['service002.jpeg'],toolTip:'Industry Research Oriented'},
          {name:`Researchers Email Outreach`,picObj:['service003.jpeg'],toolTip:'Targeted emails can help you gain opportunities such as reviewer invitations, editorial board roles, recommendation letters (even from unfamiliar experts), joint research, and PhD/postdoc positions.'},
          {name:`LLM Reply Marketing`,picObj:['service004.jpeg','service005.jpeg'],toolTip:'Boosting Visibility and Potential via AI'},
          {name:`(Free service) Reach researchers by sharing your work through academic publisher mailing lists and subscriber networks.`,toolTip:'We achieve this by working directly with publishers, academic journals, or the marketing agencies they partner with.'},
          {name:`(Free service) Share your paper with researchers through marketing channels commonly used by academic publishers and their partners.`,toolTip:'The channels depend on the journal in which your paper is submitted.'},
        ],
        dialogPic:[],
        dialogShow:false,

      }
  },
  mounted: function() {
    let userData = JSON.parse(localStorage.getItem('userData'))
    if(userData&&userData.stepTwo&&userData.stepTwo.length){
      this.checkArr =userData.stepTwo
    }
  },
  methods:{
    showPic(obj){
        // dialogPic:[],\
        this.dialogPic = [...obj]
        this.dialogShow = true
    },
    hanldGoBack(){
      localStorage.setItem('guideIndex', 1);
      this.$emit('changePage', 1);
    },
    goToNextStep(){
          console.log(2223)
          localStorage.setItem('guideIndex', 3);
          // let userData = JSON.parse(localStorage.getItem('userData'))
          // if(this.checkArr.length){
          //   userData.stepTwo = this.checkArr
          //   let str = JSON.stringify(userData)
          //   localStorage.setItem('userData', str);

          // }else{
          //   userData.stepTwo = []
          //   let str = JSON.stringify( userData)
          //   localStorage.setItem('userData', str);
          // }
          this.$emit('changePage', 3);
      }
  }
}
</script>
<style  lang="scss">
.twoDialog .el-dialog{
    width: 95% !important;
    max-width: 1100px !important;
}
.twoDialog .el-dialog__body{
  padding: 30px 0vw !important;
}

 .chooseItem .el-button+.el-button, .el-checkbox.is-bordered+.el-checkbox.is-bordered{
            margin-left: 0 !important;
        }
         .el-checkbox{
            margin-right: 0 !important;
        } 
        .el-checkbox.is-bordered.is-checked{
            border-color: #feae00 !important;
        }
        .el-checkbox__input.is-checked .el-checkbox__inner{
            border-color: #feae00 !important;
              background: #feae00 !important;
        }
        .el-checkbox__input.is-checked+.el-checkbox__label{
            color: #feae00 !important;
        }
        .el-checkbox.is-bordered.el-checkbox--small{
            width: 100%;
            display: flex;
            align-items: center;
            padding:12px 20px !important;
            border: none !important;
            height:auto !important;
        }
        .el-checkbox.is-bordered.el-checkbox--small .el-checkbox__label{
            padding-left: 20px !important;
          color: #000;
          font-size: 16px !important;
          font-style: normal !important;
          font-weight: 400 !important;
          line-height: normal !important;
          white-space: normal !important;
          word-break: break-word !important;
        }
        .el-checkbox__inner:hover{
            border-color: #feae00 !important;
        }
        @media screen and (max-width:767px) { 
 .chooseBlock .el-checkbox.is-bordered.el-checkbox--small{
            width: 100%;
            display: flex;
            align-items: center;
            padding:3vw 4vw !important;
            border: none !important;
            height:auto !important;
        }
        .chooseBlock .el-checkbox.is-bordered.el-checkbox--small .el-checkbox__label{
            padding-left: 3vw !important;
          color: #000;
          font-size: 3.4vw !important;
          font-style: normal !important;
          font-weight: 400 !important;
          line-height: normal !important;
        }
      }
</style>
<style lang="scss">
.stepTwoRoot{
    width: 100%;
    // height: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 60px 0 30px 0 ;
    gap: 30px;
    position: relative;
    .backPageItem{
      position: absolute;
      left: 100px;
      top:40px;
      width: 30px;
      height: 30px;
    }
    .circleItem{
      position: absolute;
      right: 100px;
      top:40px;
      width: 50px;
      height: 50px;
    }
    .titleBox{
      display: flex
;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    }
    .titleLine{
      color: #000;
      max-width: 900px;
      text-align: center;
      font-family: "Times New Roman";
      font-size: 40px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
    }
    .subTitle{
        margin-top: 10px;
        max-width: 900px;
        color: var(---2, #333);
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        // text-transform: capitalize;
    }
    .textBlock{
      background: #eee;
      flex: 1 1;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 15px;
      box-sizing: border-box;
      padding: 15px;
    }
    .chooseBlock{
      width: 60%;
      max-width: 800px;
      display: flex;
      // flex-direction: column;
      align-items: flex-start;
      // gap: 10px;
      .chooseName{
        display: flex;
        align-items: flex-start;
        gap: 10px;
        font-size: 16px;
      }
      .chooseSubtitle{
        // margin-top: -15px;
        font-size: 16px;
        color: #aaa;
      }
      .chooseIndex{
        font-size: 24px;
        font-weight: 700;
        font-style: italic
      }
      .chooseContext{
        flex: 1 1;
        display: flex;
        flex-direction: column;
      }
      
      
      .chooseItem{
        cursor: pointer;
        max-width: 500px;
        width: 100%;
        border-radius: 8px;
        background: var(---3, rgba(0, 0, 0, 0.03));   
      
        
       
        
        

        
        .el-radio__input.is-checked+.el-radio__label{
            color: #feae00;

        }
        .el-radio__input.is-checked .el-radio__inner{
          border-color: #feae00;
          background: #feae00;
        }
        .el-radio__inner:hover {
            border-color: #feae00;
        }
      }
    }
    .btnLine{
          display: flex;
        justify-content: center;
        align-items: center;
        .disBtn{
            display: inline-block;
            background: #E0E0E0;
            color: #fff;
            padding: 12px 40px;
            border-radius: 8px;
            font-size: 16px;
        }
        .chooseBtn{
            cursor: pointer;
            display: inline-block;
            background: #212121;
            color: #fafafa;
            padding: 12px 40px;
            border-radius: 8px;
            font-size: 16px;
        }
        .chooseBtn:hover{
            background: #424242;
        }
        .chooseBtn:active{
            background: #212121;
        }
        

    }
    .LastLine{
      flex: 1 1;
        display: flex;
        justify-content: center;
        align-items: flex-end;
      .skipBtn{
          cursor: pointer;
          padding: 12px 40px;
            font-size: 16px;
            color: #999;
        }
    }
    .LastLine2{
      flex: 1 1;
      display: flex;
        justify-content: center;
        align-items: flex-end;
        // margin-top: -20px;
        .oneItem{
          color: var(---1, #000);
          text-align: center;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px; /* 110% */
        }
        .twoItem{
          width: 90%;
          max-width: 900px;
          color: #aaa;
          text-align: center;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
    }
    .twoDialog{
      .text{
        margin-top: 5vw;
        width: 100%;
        display: none;
        text-align: center;
        font-size: 3.4vw;
      }
    }
}
@media screen and (max-width:767px) { 

  .stepTwoRoot{
    width: 100%;
    // height: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20vw 0 10vw 0;
    gap: 6vw;
    position: relative;
    .titleBox{
      padding: 0 6vw;
    }
    .backPageItem{
      position: absolute;
      left: 2vw;
      top:3vw;
      width: 4vw;
      height: 4vw;
    }
    .circleItem{
      position: absolute;
      right: 2vw;
      top:3vw;
      width: 8vw;
      height: 8vw;
    }
    .titleLine{
      color: #000;
      text-align: center;
      font-family: "Times New Roman";
      font-size: 6vw;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
    }
    .subTitle{
        margin-top: 2vw;
        width: 100%;
        max-width: 600px;
        color: var(---2, #333);
        text-align: center;
        font-size: 3.4vw;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        // text-transform: capitalize;
    }
    .textBlock{
      gap: 2vw;
      padding-bottom: 0;
      padding: 5vw 6vw;
    }
    .chooseBlock{
      width: 100%;;
      display: flex;
      // gap: 3vw;
      .chooseName{
        display: flex;
        align-items: flex-start;
        gap: 1vw;
        font-size: 3.4vw;
      }
      .chooseSubtitle{
        // margin-top: -15px;
        font-size: 3.4vw;
        color: #aaa;
      }
      .chooseIndex{
        font-size: 5vw;
      }
      .chooseItem{
        cursor: pointer;
        max-width: 100%;
        width: 100%;
        border-radius: 8px;
        background: var(---3, rgba(0, 0, 0, 0.03));  
        .el-radio__input.is-checked+.el-radio__label{
            color: #feae00;

        }
        .el-radio__input.is-checked .el-radio__inner{
          border-color: #feae00;
          background: #feae00;
        }
        .el-radio__inner:hover {
            border-color: #feae00;
        }
      }
    }
    .btnLine{
          display: flex;
        justify-content: center;
        align-items: center;
        .disBtn{
            display: inline-block;
            background: #E0E0E0;
            color: #fff;
            padding: 1.2vw 4vw;
            border-radius: 8px;
            font-size: 3.4vw;
        }
        .chooseBtn{
            cursor: pointer;
            display: inline-block;
            background: #212121;
            color: #fafafa;
            padding: 1.2vw 4vw;
            border-radius: 8px;
            font-size: 3.4vw;
        }
        .chooseBtn:hover{
            background: #424242;
        }
        .chooseBtn:active{
            background: #212121;
        }
        

    }
    .LastLine{
      flex: 1 1;
        display: flex;
        justify-content: center;
        align-items: flex-end;
      .skipBtn{
          cursor: pointer;
          padding: 1.2vw 4vw;
            font-size: 3.4vw;
            color: #999;
        }
    }
    .LastLine2{
        flex: 1 1;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        // margin-top: -4vw;
        .oneItem{
            color: var(---1, #000);
            text-align: center;
            font-size: 3.4vw;
            font-style: normal;
            font-weight: 400;
            line-height: 1.3; /* 110% */
          }
          .twoItem{
            width: 90%;
            max-width: 900px;
            color: #aaa;
            text-align: center;
            font-size: 3vw;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
          }
    }
    .twoDialog{
      .text{
        margin-top: 5vw;
        width: 100%;
        display: block;
        text-align: center;
        font-size: 3.4vw;
      }
    }
}
}


@media screen  and (min-width: 767px) and (max-width: 1200px){
  .stepTwoRoot{
    width: 100%;
    // height: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 6vw 0 3vw 0;
    gap: 3vw;
    position: relative;
    .backPageItem{
      position: absolute;
      left: 6vw;
      top:2vw;
      width: 5vw;
      height: 5vw;
    }
    .circleItem{
      position: absolute;
      right: 6vw;
      top:2vw;
      width: 5vw;
      height: 5vw;
    }
    .titleLine{
      max-width: 75vw;
      color: #000;
      text-align: center;
      font-family: "Times New Roman";
      font-size: 3.2vw;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
    }
    .subTitle{
        margin-top: 10px;
        max-width: 70vw;
        color: var(---2, #333);
        text-align: center;
        font-size: 1.6vw;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        // text-transform: capitalize;
    }
    .textBlock{
      gap: 1vw;
    }
    .chooseBlock{
      display: flex;
      // flex-direction: column;
      // gap: 2vw;
      .chooseName{
        display: flex;
        align-items: flex-start;
        gap: 1vw;
        font-size: 1.6vw;
      }
      .chooseSubtitle{
        // margin-top: -15px;
        font-size: 1.6vw;
        color: #aaa;
      }
      .chooseIndex{
        font-size: 3vw;
      }
      .chooseItem{
        cursor: pointer;
        max-width: 500px;
        width: 100%;
        border-radius: 8px;
        background: var(---3, rgba(0, 0, 0, 0.03));   
      
        
       
        
        

        
        .el-radio__input.is-checked+.el-radio__label{
            color: #feae00;

        }
        .el-radio__input.is-checked .el-radio__inner{
          border-color: #feae00;
          background: #feae00;
        }
        .el-radio__inner:hover {
            border-color: #feae00;
        }
      }
    }
    .btnLine{
          display: flex;
        justify-content: center;
        align-items: center;
        .disBtn{
            display: inline-block;
            background: #E0E0E0;
            color: #fff;
            padding: 1.2vw 4vw;
            border-radius: 8px;
            font-size: 1.6vw;
        }
        .chooseBtn{
            cursor: pointer;
            display: inline-block;
            background: #212121;
            color: #fafafa;
            padding: 1.2vw 4vw;
            border-radius: 8px;
            font-size: 1.6vw;
        }
        .chooseBtn:hover{
            background: #424242;
        }
        .chooseBtn:active{
            background: #212121;
        }
        

    }
    .LastLine{
      flex: 1 1;
        display: flex;
        justify-content: center;
        align-items: flex-end;
      .skipBtn{
          cursor: pointer;
          padding: 1.2vw 4vw;
            font-size: 1.6vw;
            color: #999;
        }
    }
    .LastLine2{
        flex: 1 1;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        // margin-top: -1vw;
        .oneItem{
          color: var(---1, #000);
          text-align: center;
          font-size: 1.6vw;
          font-style: normal;
          font-weight: 400;
          line-height: 1.3; /* 110% */
        }
        .twoItem{
          width: 90%;
          max-width: 900px;
          color: #aaa;

          text-align: center;
          font-size: 1.2vw;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
    }
}
}
</style>